import type { PermissionMap } from './permissions';
import type { Role } from './roles';

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export interface ApiErrorBody {
  statusCode: number;
  code: string;
  message: string;
  details?: unknown;
}

export type UserType = 'staff' | 'exporter';
export type UserStatus = 'active' | 'inactive' | 'suspended' | 'pending_invite';

export const USER_STATUSES: readonly UserStatus[] = ['active', 'inactive', 'suspended', 'pending_invite'];

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  role: Role;
  userType: UserType;
  department: string | null;
  exporterId: string | null;
  mustChangePassword: boolean;
}

export interface AuthSession {
  accessToken: string;
  /** Seconds until the access token expires. */
  expiresIn: number;
  user: AuthUser;
  permissions: PermissionMap;
}

export const MIN_PASSWORD_LENGTH = 8;
